<div class="confirm-dialog">
  <h2 mat-dialog-title>Edit Threshold</h2>
  <div class="inner">
    <button [mat-dialog-close]="false" aria-label="Close" class="dialog__close-btn close-button">
      <i class="fa fa-times">close</i>
    </button>
    <div mat-dialog-content [align]="'center'" style="white-space: pre-line; line-height: 30px">
      <b>Cron Description</b> - {{data.cronDescriptor}}
      <br>
      <b>Transit Time</b> - {{data.transitTime != "*" ? data.transitTime: "ALL"}}
      <br>
      <label for="threshold">Threshold - </label>
      <br>
      <input type="range" min="0" max="100" class="pure-input-2-3 pure-form pure-form-stacked" id="threshold"  [(ngModel)]="threshold" style="width: 80%; height: 23px; margin-bottom: 5px" />
      <input
        class="form-control mb-4 ng-untouched ng-pristine ng-valid"
        readonly
        name="cronForm"
        [(ngModel)]="threshold">
    </div>
    <div mat-dialog-actions [align]="'end'">
      <button class="confirm-dialog-button-cancel" mat-raised-button (click)="onCancel()">Cancel</button>
      <button class="confirm-dialog-button-confirm" mat-raised-button color="primary" (click)="onSubmit()">Submit</button>
    </div>
  </div>
</div>
<div class="overlay" ></div>
